var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{selected: this.selected},attrs:{"id":"language-container"}},[_c(this.flagComponentName,{tag:"component",staticClass:"flag"}),_c('p',{staticClass:"attensi-overline locale-name-text"},[_vm._v(_vm._s(this.localeName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }